import React, { useContext, useEffect, useState } from "react";
import { UrlContext } from "../../contexts/UrlContext";

export default function ViewProjectInfo({ project_id }) {
  const { API_URL } = useContext(UrlContext);
  const [projectInfo, setProjectInfo] = useState({});
  const [showProjectInfo, setShowProjectInfo] = useState(false);
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}view-list-info/${project_id}`);

      if (!response.ok) {
        throw new Error(`Request failed with status: ${response.status}`);
      }
      const data = await response.json();
      setProjectInfo(data.projectInfo);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (showProjectInfo) {
      fetchData();
    }
  }, [showProjectInfo]);

  return (
    <>
      <button
        className="btn"
        title="View Project Info"
        onClick={() => setShowProjectInfo(true)}
      >
        <i className="fa-solid fa-eye"></i> List Info
      </button>

      {showProjectInfo && (
        <div className="project-info-popup-wrapper">
          <div className="tab-pane fade show project-info-div">
            <i
              className="pjinfo-close-icon fa-regular fa-rectangle-xmark"
              onClick={() => setShowProjectInfo(false)}
            ></i>
            <div className="form-card review-project-setup">
              <h4 className="text-muted">List Details</h4>
              <div className="row">
                <p className="col-3 text-muted">List Name</p>
                <p className="col-9">{projectInfo.name}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">List Description</p>
                <p
                  className="col-9"
                  style={{
                    wordWrap: "break-word",
                    wordBreak: "normal",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {projectInfo.description}
                </p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Region</p>
                <p className="col-9">{projectInfo.region}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Country</p>
                <p className="col-9">{projectInfo.country}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Industy Preference</p>
                <p className="col-9">{projectInfo.industryPref}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Industy</p>
                <p className="col-9">{projectInfo.industry}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">List Category</p>
                <p className="col-9">{projectInfo.projCategory}</p>
              </div>
              <h4 className="text-muted mt-3">Profile Details</h4>
              <div className="row">
                <p className="col-3 text-muted">Profile Type</p>
                <p className="col-9">{projectInfo.consExp}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Seniority</p>
                <p className="col-9">{projectInfo.yearsOfExperience}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Skills</p>
                <p className="col-9">{projectInfo.skills}</p>
              </div>
              <div className="row">
                <p className="col-3 text-muted">Language</p>
                <p className="col-9">{projectInfo.language}</p>
              </div>
            </div>
            <div>
              <center>
                <button
                  type="button"
                  className="btn base-btn prjdetails-editCancel"
                  onClick={() => setShowProjectInfo(false)}
                >
                  Close
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
